<!-- Footer -->
<p class="clearfix mb-0">
  <!-- Firma de B.R.A.I.N.: solo en el layout nuevo (versión 2) -->
  <span class="float-md-left d-block d-md-inline-block mt-50" *ngIf="!isMasterLayout">
    &copy; {{ year }}
    B.R.A.I.N. by <a class="ml-25" href="https://belivcompany.com" target="_blank">Beliv</a> - Powered by Business Management
  </span>
  <!-- Firma de Beliv App: solo en el layout (versión 1) -->
  <span class="float-md-left d-block d-md-inline-block mt-50" *ngIf="isMasterLayout">
    &copy; {{ year }}
    <a class="ml-25" href="https://belivcompany.com" target="_blank">Beliv</a> App - Powered by Business Management
  </span>
  <span class="float-md-right d-none d-md-block">
    <!-- Realizado con <span [data-feather]="'heart'" [class]="'pink'"></span> -->
    <!-- <img src="assets/images/logo/dna-logo.png" alt="brand-logo" height="28" *ngIf="coreConfig.layout.skin != 'dark'" />
    <img src="assets/images/logo/dna-logo-white.png" alt="brand-logo" height="28" *ngIf="coreConfig.layout.skin == 'dark'" /> -->
  </span>
</p>
<!--/ Footer -->

<!-- Move to top Button-->
<app-scroll-top *ngIf="coreConfig.layout.scrollTop"></app-scroll-top>
